import { Location, LocationDescriptor } from 'history';
import React, { PureComponent } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import linkStyles from '~/UI/Button/link.less';

interface Props extends Omit<React.ComponentPropsWithRef<ReactRouterLink>, 'to' | 'referrerPolicy'> {
	disabled?: boolean;
	children: React.ReactNode;
	styles: { button: string };
	to?: LocationDescriptor | ((location: Location) => LocationDescriptor);
}

export default class Link extends PureComponent<Props> {
	public static defaultProps = {
		children: null,
		styles: linkStyles,
	};

	public render() {
		const { children, styles, to = null, ...props } = this.props;

		return to !== null ? (
			<ReactRouterLink className={styles.button} to={to} {...props}>
				{children}
			</ReactRouterLink>
		) : (
			<a className={styles.button} href={this.props.href} {...props}>
				{children}
			</a>
		);
	}
}
